import { render } from "./BrakeDamage.vue?vue&type=template&id=aa6c6208&scoped=true&ts=true"
import script from "./BrakeDamage.vue?vue&type=script&lang=ts"
export * from "./BrakeDamage.vue?vue&type=script&lang=ts"

import "./BrakeDamage.vue?vue&type=style&index=0&id=aa6c6208&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa6c6208"]])

export default __exports__